/**
 * <recipe-print> — bouton « Imprimer » de la page recette.
 *
 * Progressive enhancement : sans JavaScript, le bouton est `hidden` (il ne ferait
 * rien d'utile). Le JS le révèle et déclenche l'impression native du navigateur.
 * Aucun appel réseau. Le bouton « Aller à la recette » voisin est un simple lien
 * d'ancre — il fonctionne sans JS, il n'est pas géré ici.
 */
class RecipePrint extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-recipe-print]');
    if (!this.button) return;
    this.button.hidden = false;
    this.onClick = () => window.print();
    this.button.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onClick);
  }
}

if (!customElements.get('recipe-print')) {
  customElements.define('recipe-print', RecipePrint);
}
